import { render, staticRenderFns } from "./roleMange.vue?vue&type=template&id=514d3190&scoped=true&"
import script from "./roleMange.vue?vue&type=script&lang=js&"
export * from "./roleMange.vue?vue&type=script&lang=js&"
import style0 from "./roleMange.vue?vue&type=style&index=0&id=514d3190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d3190",
  null
  
)

export default component.exports